export default "__VITE_ASSET__DD1eKyaE__"